/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ProductEditions {
    OrgaModule = 12,
    TechModule = 18,
    DataModule = 23,
    LinkModule = 28,
    SyncLocationAddon = 31,
    NotificationAddon = 43,
    TeamModule = 44,
    PumpAddon = 48,
}
